import axios from 'axios'
import { EXCLUIR_AGENDAMENTO_VIAGEM_PASSAGEIRO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirAgendamentoViagemPassageiro (agendamentoViagemPassageiroId, empresaId) {
  const url = `${URL}/agendamento-viagem/excluir/passageiro/${agendamentoViagemPassageiroId}/empresa/${empresaId}`;

  return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_AGENDAMENTO_VIAGEM_PASSAGEIRO,
        payload: response
      })
  );
}
